import React from "react";
import { useSelector } from "react-redux";
import { formatNumber, Unit } from "../../helpers/unit";
import { capitalize } from "../../helpers/common";
import Logo from '../../../assets/images/login-logo-gray.png';
import moment from "moment";
import { DISPLAY_DATETIME_FORMAT3 } from "../../constants";

export const BulkLoadPreviewData = React.forwardRef((props, ref) => {
  let { load, loadCount, previewFormData, currentIdx } = props;
  const unit = Unit.getInstance();
  load = {
    ...load,
    ...(load.load_params || {})
  };

  const weightShortName = useSelector((state) => state.user.settings.weightShortName);
  const farmName = useSelector((state) => state.farm.currentFarm.farm_name);
  const farmAddress = useSelector((state) => state.farm.farmAddress);
  const timezoneIdentifier = useSelector(
    (state) => state.farm.currentFarm.timezone_identifier
  );

  const now = moment().utc().tz(timezoneIdentifier);
  const timezoneId = now.zoneAbbr();
  const currentDateTime = moment(now).format(DISPLAY_DATETIME_FORMAT3);

  const getValue = (load, field) => {
    let value = load[field.key] ? load[field.key] : null;
    if (!value || value === "Unknown") return "";

    if (Array.isArray(value)) {
      value = value.join(', ');
    }
    if (field.type === "weight") {
      value = unit.toWeight(value, 2);
      return formatNumber(value);
    }

    return value;
  }


  return (
    <div className="content-body print_container" ref={ref}>
      <div className="print_bg_img">
        <img alt="" src={Logo} />
      </div>
      <div className="print-main-container">
        <div className="print-header with-date-time">
          <section>
            <div className="farm-name">{farmName}</div>
            <div className="header-align">
              {farmAddress.address && farmAddress.address.addressLineOne
                ? `${farmAddress.address.addressLineOne},`
                : null}
            </div>
            <div className="header-align">
              {farmAddress.address && farmAddress.address.addressLineTwo
                ? farmAddress.address.addressLineTwo
                : null}
            </div>
            <div className="header-align">{`${farmAddress.address && farmAddress.address.city
              ? `${farmAddress.address.city}, `
              : ""
              } 
                    ${farmAddress.address && farmAddress.address.state
                ? `${farmAddress.address.state}, `
                : ""
              }
                    ${farmAddress.address && farmAddress.address.zipCode
                ? `${farmAddress.address.zipCode}, `
                : ""
              }`}</div>
            <div className="header-align">
              {farmAddress.phone && farmAddress.phone[0]
                ? farmAddress.phone[0]
                : null}
            </div>
          </section>
          <section className="header-right-_section">
            <div className="header-date-time">
              {currentDateTime} {timezoneId}
            </div>
          </section>
        </div>
        <div className="print-body">
          <div className="container">
            {previewFormData.reduce((rows, item, index, arr) => {
              if (index % 2 === 0) {
                const next = arr[index + 1];
                rows.push([item, next]);
              }
              return rows;
            }, []).map(([left, right], idx) => (
              <div className="row-align" key={idx}>
                {/* LEFT COLUMN */}
                <div className="left-col-algin">{left.label.toUpperCase()}
                  {left.type && left.type === 'weight' && <span className="weight-name">{` (${capitalize(weightShortName)})`}</span>} :</div>
                <div className="answer-border answer">
                  {getValue(load, left)}
                </div>

                {/* RIGHT COLUMN */}
                {right ? (
                  <>
                    <div className="right-col-algin">{right.label.toUpperCase()}
                      {right.type && right.type === 'weight' && <span className="weight-name">{` (${capitalize(weightShortName)})`}</span>}:</div>
                    <div className="answer-border answer">
                      {getValue(load, right)}
                    </div>
                  </>
                ) : null}
              </div>
            ))}
          </div>
        </div>
        {(loadCount > 0 && loadCount !== (currentIdx + 1)) ? <div style={{ pageBreakAfter: "always" }}></div> : null}
      </div>
    </div>
  );
});